import React from 'react';
import { colors } from '../constants';
import styled from 'styled-components';

const ArrowSvg = ({ width, height, className }) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 13 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.44836 6.5L6.27595 1.5M6.27595 1.5L11.1035 6.5M6.27595 1.5L6.27595 15.5"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Arrow = styled(ArrowSvg)`
  margin-right: 5px;
  path {
    stroke: ${({ color }) => color};
  }

  ${({ rotate }) => rotate && `transform: rotate(${rotate}deg);`}
`;

Arrow.displayName = 'Arrow';

Arrow.defaultProps = {
  width: '13',
  height: '17',
  color: colors.darkGrey,
  rotate: 90,
};

export default Arrow;
